/* ---------- the pop ----------
   Declared first, with var (not let) and on window, so it is available to
   every page in the theme no matter what happens further down this file.
   The product page, the cases band and the games all call pop(); only the
   home page carries the carousel markup the rest of this file expects. */
var actx=null;
function pop(){
  try{
    actx=actx||new (window.AudioContext||window.webkitAudioContext)();
    if(actx.state==='suspended') actx.resume();
    const t=actx.currentTime;
    const o=actx.createOscillator(), g=actx.createGain();
    o.type='sine'; o.frequency.setValueAtTime(780,t); o.frequency.exponentialRampToValueAtTime(130,t+.075);
    g.gain.setValueAtTime(.0001,t); g.gain.exponentialRampToValueAtTime(.45,t+.006);
    g.gain.exponentialRampToValueAtTime(.0001,t+.17);
    o.connect(g).connect(actx.destination); o.start(t); o.stop(t+.2);
    const len=2400, buf=actx.createBuffer(1,len,actx.sampleRate), dat=buf.getChannelData(0);
    for(let i=0;i<len;i++) dat[i]=(Math.random()*2-1)*Math.pow(1-i/len,7);
    const n=actx.createBufferSource(); n.buffer=buf;
    const ng=actx.createGain(); ng.gain.value=.25;
    n.connect(ng).connect(actx.destination); n.start(t);
  }catch(e){}
}
window.pop=pop;

const F=[
 {k:"lime",tint:"#D8F0B8",tx:"#1E3D08",n:"Lime Zing",bg:"#8FD14F",fg:"#17300A",chip:"#EDF8DA",deep:"#0F2A02",cal:50,marble:"#3E7A2E",
  d:"Sharp lime, real ginger, cool mint at the finish. The one you reach for when it's 105° outside.",
  m:"Real lime, ginger &amp; mint extracts",long:"The one you reach for when it is 105&deg; outside. Sharp lime over real ginger, with cool mint arriving right at the end."},
 {k:"orange",tint:"#C3CFF5",tx:"#12235F",n:"Spiced Orange",bg:"#2547C9",fg:"#FFFFFF",chip:"#E2E8FB",deep:"#12235F",cal:50,marble:"#1B3286",
  d:"Juicy orange up front, ginger and cardamom underneath. Familiar for a second, then not.",
  m:"Real orange, ginger &amp; cardamom extracts",long:"Juicy orange up front, then ginger and cardamom underneath. Familiar for about a second, then not."},
 {k:"lychee",tint:"#FFD3CD",tx:"#5C120C",n:"Lychee Mint",bg:"#FB6F63",fg:"#3F0B07",chip:"#FFE7E2",deep:"#3F0B07",cal:35,marble:"#C94236",
  d:"Floral, delicate lychee with a clean mint finish. The gentlest one in the box.",
  m:"Real lychee &amp; mint extracts",long:"Floral and delicate, with a clean mint finish. The gentlest one in the box, and the one soda sceptics finish first."},
 {k:"mango",tint:"#EFC2E6",tx:"#4C0740",n:"Mango Passion",bg:"#A5178A",fg:"#FFFFFF",chip:"#F7E0F1",deep:"#4C0740",cal:45,marble:"#71105E",
  d:"Ripe mango cut with tart passion fruit and a mint lift. The loudest flavour we make.",
  m:"Real mango, passion fruit &amp; mint extracts",long:"Ripe mango cut with tart passion fruit and a mint lift. The loudest flavour we make."}
];
const LOGOS=(window.GOLI&&window.GOLI.logos)||{};
const LOGOS_LIGHT=(window.GOLI&&window.GOLI.logosLight)||{};
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
let cur=0, timer=null, paused=reduce, pdpView='cn';

const LINES=[["Every goli has a story","A classic soda revived","Same pop, new twist","Real fruit, traditional spices"],
             ["Pop it","Twist it","Feel it","One marble, a thousand memories"],
             ["From the soda kadai to the world","Since 1872","Same feeling, next generation"]];
['tk1','tk2'].forEach((id,n)=>{
  const el=$('#'+id); if(!el) return;
  const out=[]; for(let r=0;r<10;r++) LINES[n].forEach(t=>out.push('<span>'+t+' <i>&#10022;</i></span>'));
  el.innerHTML=out.join('');
});

function paint(i,animate){
  cur=i; const f=F[i], r=document.documentElement.style;
  r.setProperty('--bg',f.bg); r.setProperty('--fg',f.fg);
  r.setProperty('--chip',f.chip); r.setProperty('--deep',f.deep);
  $$('.slide').forEach((s,j)=>s.classList.toggle('on',j===i));
  $$('.dot').forEach((d,j)=>{d.classList.toggle('on',j===i);d.setAttribute('aria-current',j===i)});
  const cards=$$('.spotcard'), track=$('#spotTrack');
  if(cards[i]&&track) track.style.transform='translateX('+(-cards[i].offsetLeft)+'px)';
  $$('.sdot').forEach((d,j)=>{d.classList.toggle('on',j===i);d.setAttribute('aria-current',j===i)});
  const txt=(id,v)=>{const e=$(id); if(e) e.textContent=v;};
  txt('#nowName',f.n); txt('#nowDesc',f.d); txt('#fCal',f.cal);
  const pn=document.getElementById('pdpName');
  if(pn){
    const set=(id,v)=>{const e=document.getElementById(id); if(e) e.innerHTML=v;};
    set('pdpName',f.n); set('pdpCrumb',f.n); set('pdpDesc',f.d);
    set('pdpCal',f.cal); set('pdpCal2',f.cal); set('pdpCalPill',f.cal); set('pdpLong',f.long); set('pdpExt',f.m);
    const buy=document.getElementById('pdpBuy');
    if(buy){ buy.dataset.buy=f.n; }
    const main=document.getElementById('pdpMain');
    if(main){ main.style.backgroundImage='var(--'+pdpView+'-'+f.k+')';
              main.style.backgroundSize = pdpView==='cn' ? 'auto 78%' : 'contain';
              // a cut-out can needs a contrasting field behind it, not its own colour
              main.style.setProperty('--tile', pdpView==='cn' ? f.bg : 'transparent');
              main.setAttribute('aria-label','Goli Twist '+f.n); }
    $$('#pdpThumbs .thumb').forEach(t=>{ t.style.backgroundImage='var(--'+t.dataset.v+'-'+f.k+')';
      t.style.backgroundSize = t.dataset.v==='cn' ? 'auto 74%' : 'contain';
      t.style.setProperty('--tile', t.dataset.v==='cn' ? f.bg : 'transparent'); });
    $$('#sfGrid .sf').forEach((b,j)=>b.classList.toggle('on',j===i));
    const vc=document.getElementById('vsCan');
    if(vc) vc.style.backgroundImage='var(--cn-'+f.k+')';
  }
  const cc=document.getElementById('contactCan');
  if(cc){cc.style.backgroundImage='var(--cn-'+f.k+')'; cc.setAttribute('aria-label','Goli Twist '+f.n+' can');}
  $$('.thenslide').forEach((s,j)=>s.classList.toggle('on',j===i));
  $$('.dsvslide').forEach((s,j)=>s.classList.toggle('on',j===i));
  const ext=f.m.replace(/&amp;/g,'&');
  txt('#coCal',f.cal+' calories');
  txt('#coExt',ext);
  document.documentElement.style.setProperty('--marble', f.marble);
  /* only the home carousel drives the logo; elsewhere Liquid renders the right one */
  if(document.getElementById('stage'))
  [['brandLogo',LOGOS],['footLogo',LOGOS_LIGHT]].forEach(([id,set])=>{
    const el=document.getElementById(id);
    if(el && el.dataset.k!==f.k){
      el.dataset.k=f.k;
      el.style.opacity='0';
      setTimeout(()=>{ el.src=set[f.k]; el.style.opacity='1'; }, 140);
    }
  });
  $$('.marble').forEach((m,j)=>{m.classList.toggle('on',j===i);m.setAttribute('aria-pressed',j===i)});
  if(animate&&!reduce){const m=$$('.marble')[i];if(m){m.classList.remove('drop');void m.offsetWidth;m.classList.add('drop');}}
}
function go(i,manual){paint((i+F.length)%F.length,true); t0=performance.now(); if(manual) restart(); else paintScrub();}
const DWELL=3000;                 // 3 seconds per poster
let t0=0, scrubbing=false;
function onStore(){ return ((location.hash.replace('#/','').split('#')[0])||'store')==='store'; }
function restart(){
  clearInterval(timer); t0=performance.now();
  if(!paused && !scrubbing && onStore()) timer=setInterval(()=>go(cur+1),DWELL);
  paintScrub();
}
/* scrubber: position = current poster + progress through its 3s dwell */
const scrub=$('#scrub'), scrubIn=$('#scrubIn'), scrubFill=$('#scrubFill'), scrubKnob=$('#scrubKnob');
const SPAN=scrubIn ? +scrubIn.max : 400;       // 400 units across 4 posters = 100 per poster
function setScrub(v){
  if(!scrubFill||!scrubKnob||!scrubIn) return;
  const pct=(v/SPAN)*100;
  scrubFill.style.width=pct+'%'; scrubKnob.style.left=pct+'%';
  if(document.activeElement!==scrubIn) scrubIn.value=v;
}
function paintScrub(){
  if(scrubbing) return;
  const frac = (paused||!timer) ? 0 : Math.min((performance.now()-t0)/DWELL,1);
  setScrub(Math.min((cur+frac)*(SPAN/F.length), SPAN));
}
function tickScrub(){ paintScrub(); requestAnimationFrame(tickScrub); }
requestAnimationFrame(tickScrub);

function scrubTo(v){
  const i=Math.min(Math.floor(v/(SPAN/F.length)), F.length-1);
  setScrub(v);
  if(i!==cur) paint(i,true);
}
if(scrubIn){
  scrubIn.addEventListener('pointerdown',()=>{scrubbing=true;scrub.classList.add('drag');clearInterval(timer);timer=null;});
  scrubIn.addEventListener('input',e=>scrubTo(+e.target.value));
  const endScrub=()=>{ if(!scrubbing) return; scrubbing=false; scrub.classList.remove('drag'); restart(); };
  scrubIn.addEventListener('pointerup',endScrub);
  scrubIn.addEventListener('pointercancel',endScrub);
  scrubIn.addEventListener('blur',endScrub);
  scrubIn.addEventListener('keydown',e=>{
    if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){
      e.preventDefault();
      const i = e.key==='Home'?0 : e.key==='End'?F.length-1 : (cur + (e.key==='ArrowRight'?1:-1) + F.length)%F.length;
      go(i,true);
    }
  });
}

const rail=$('#rail');
if(rail) F.forEach((f,i)=>{
  const b=document.createElement('button');
  b.className='marble'; b.style.background=f.marble;
  b.setAttribute('aria-label','Show '+f.n); b.setAttribute('aria-pressed',i===0);
  b.onclick=()=>{go(i,true);pop()};
  rail.appendChild(b);
});
$$('.dot').forEach(d=>d.onclick=()=>go(+d.dataset.i,true));

/* The two blocks below drive the old single-page product view, which is
   markup carrying data-f / data-v attributes. The Liquid product section
   renders real links and its own gallery, so bind only where the old
   markup is actually present — otherwise these would hijack the section. */
$$('#sfGrid .sf').forEach(b=>{
  if(b.dataset.f===undefined) return;
  b.onclick=()=>{ const i=+b.dataset.f; paint(i,false); pop();
    try{ history.replaceState(null,'','#/product/'+F[i].k); }catch(err){} };
});
$$('#pdpThumbs .thumb').forEach(t=>{
  if(t.dataset.v===undefined) return;
  t.onclick=()=>{
    pdpView=t.dataset.v;
    $$('#pdpThumbs .thumb').forEach(o=>o.classList.toggle('on',o===t));
    const m=document.getElementById('pdpMain');
    if(m){ m.style.backgroundImage='var(--'+pdpView+'-'+F[cur].k+')';
           m.style.backgroundSize = pdpView==='cn' ? 'auto 78%' : 'contain';
           m.style.setProperty('--tile', pdpView==='cn' ? F[cur].bg : 'transparent'); }
  };
});
$$('.sdot').forEach(d=>d.onclick=()=>go(+d.dataset.s,true));
const spotPrev=$('#spotPrev'), spotNext=$('#spotNext');
if(spotPrev) spotPrev.onclick=()=>go(cur-1,true);
if(spotNext) spotNext.onclick=()=>go(cur+1,true);
const spotWrap=document.querySelector('.spotwrap');
if(spotWrap){
  spotWrap.addEventListener('mouseenter',()=>clearInterval(timer));
  spotWrap.addEventListener('mouseleave',restart);
}
const nextBtn=$('#next'), prevBtn=$('#prev'), pauseBtn=$('#pause');
if(nextBtn) nextBtn.onclick=()=>go(cur+1,true);
if(prevBtn) prevBtn.onclick=()=>go(cur-1,true);
if(pauseBtn) pauseBtn.onclick=e=>{paused=!paused;e.target.textContent=paused?'Play':'Pause';
  e.target.setAttribute('aria-label',paused?'Resume slideshow':'Pause slideshow');restart();};
const stage=$('#stage');
if(stage){
  stage.addEventListener('mouseenter',()=>clearInterval(timer));
  stage.addEventListener('mouseleave',restart);
  stage.addEventListener('focusin',()=>clearInterval(timer));
  stage.addEventListener('focusout',restart);
  document.addEventListener('visibilitychange',()=>document.hidden?clearInterval(timer):restart());
}
if(reduce && pauseBtn) pauseBtn.textContent='Play';

const popbtn=$('#popbtn');
if(popbtn) popbtn.onclick=()=>{
  popbtn.classList.remove('pressed'); void popbtn.offsetWidth; popbtn.classList.add('pressed');
  pop();
  const t=$('#poptext'); if(!t) return;
  t.textContent='POP!';
  setTimeout(()=>{t.textContent='Press the goli'},900);
};


function openCart(o){
  const d=$('#drawer'), s=$('#scrim');
  if(!d) return;
  d.classList.toggle('open',o); d.setAttribute('aria-hidden',!o);
  if(s) s.classList.toggle('open',o);
}
const cartbtn=$('#cartbtn'), closeCart=$('#closeCart'), scrim=$('#scrim');
/* #cartbtn is a real link to /cart so it still works without JS. With JS we
   want the drawer, so stop the navigation — otherwise the drawer opened and
   the page immediately left, and on /cart itself it just reloaded. */
if(cartbtn) cartbtn.addEventListener('click',e=>{ e.preventDefault(); openCart(true); });
if(closeCart) closeCart.onclick=()=>openCart(false);
if(scrim)     scrim.onclick=()=>openCart(false);
document.addEventListener('keydown',e=>{
  const d=$('#drawer');
  if(e.key==='Escape'&&d&&d.classList.contains('open')) openCart(false);
});

const EM=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const nl=$('#nl'), nlbtn=$('#nlbtn');
if(nl) nl.addEventListener('input',()=>{const e=$('#e-nl'); if(e) e.classList.remove('show'); nl.classList.remove('bad')});
if(nl&&nlbtn) nlbtn.onclick=()=>{
  const v=nl.value.trim(), err=$('#e-nl'), ok=$('#nlok');
  if(!EM.test(v)){ if(err) err.classList.add('show'); nl.classList.add('bad'); nl.focus(); return; }
  if(ok) ok.textContent="You're on the list. We'll be in touch when we're near you.";
  nl.value=''; pop();
};

function headerH(){ const hd=document.querySelector('header'); return hd?hd.offsetHeight:72; }
/* Calm scrolling.
   Native smooth-scroll runs at a fixed speed, so a long page becomes a blur.
   This eases in and out over a controlled time, and for very long distances it
   closes most of the gap instantly first — so you never watch the page rip past. */
let scrollRAF=null;
function easeInOutCubic(p){ return p<.5 ? 4*p*p*p : 1-Math.pow(-2*p+2,3)/2; }
function smoothTo(target){
  if(scrollRAF) cancelAnimationFrame(scrollRAF);
  const max=Math.max(document.documentElement.scrollHeight-window.innerHeight,0);
  const end=Math.max(0,Math.min(target,max));
  if(reduce){ window.scrollTo(0,end); return; }
  const CAP=window.innerHeight*1.6;                 // never animate further than this
  let from=window.pageYOffset;
  if(Math.abs(end-from)>CAP){
    from = end>from ? end-CAP : end+CAP;
    window.scrollTo(0,Math.max(0,Math.min(from,max)));
    from=window.pageYOffset;
  }
  const dist=end-from;
  if(Math.abs(dist)<2){ window.scrollTo(0,end); return; }
  const dur=Math.min(420+Math.abs(dist)*0.55,760);  // short trips quick, long ones unhurried
  const t0=performance.now();
  (function step(now){
    const p=Math.min((now-t0)/dur,1);
    window.scrollTo(0,from+dist*easeInOutCubic(p));
    if(p<1) scrollRAF=requestAnimationFrame(step); else scrollRAF=null;
  })(t0);
}
function jump(frag){
  const t=document.getElementById(frag);
  if(!t) return false;
  smoothTo(t.getBoundingClientRect().top+window.pageYOffset-headerH()-14);
  return true;
}
/* Measure the words for real and shrink until they fit their column.
   No reliance on font metrics, container queries, or my arithmetic. */
/* a shadow once the page has moved, so the bar reads as floating above it */
(function(){
  const hd=document.querySelector('header');
  if(!hd) return;
  const onScroll=()=>hd.classList.toggle('stuck', window.pageYOffset > 4);
  addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

function fitWords(){
  $$('.dsvword').forEach(w=>{
    const s=w.firstElementChild; if(!s) return;
    s.style.fontSize='';
    const avail=w.clientWidth;
    if(!avail) return;
    let fs=parseFloat(getComputedStyle(s).fontSize)||48, guard=0;
    while(s.scrollWidth>avail*0.99 && fs>12 && guard++<80){
      fs*=0.97; s.style.fontSize=fs+'px';
    }
  });
}
let fitT=null;
function scheduleFit(){ clearTimeout(fitT); fitT=setTimeout(fitWords,80); }
addEventListener('resize',scheduleFit);
addEventListener('load',fitWords);
if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fitWords);
requestAnimationFrame(()=>requestAnimationFrame(fitWords));

/* legacy chapters */
const legS=$$('.legslide'), legD=$$('.legdot');
const LEG_DWELL=12000;                      // measured against the reading time of the longest chapter
let legI=0, legT=null, legPaused=reduce, legStarted=false, legT0=0;
const legStage=document.getElementById('legStage');
const legRoot=document.getElementById('legacy');

function legHeight(){
  if(!legStage) return;
  const a=legS[legI];
  if(a) legStage.style.height=a.offsetHeight+'px';
}
function legGo(i){
  legI=(i+legS.length)%legS.length;
  legS.forEach((s,j)=>s.classList.toggle('on',j===legI));
  legD.forEach((d,j)=>{
    d.classList.toggle('on',j===legI);
    d.setAttribute('aria-selected',j===legI);
    d.style.setProperty('--p','0%');
  });
  legT0=performance.now();
  requestAnimationFrame(legHeight);
}
function legRestart(){
  clearInterval(legT); legT=null;
  legT0=performance.now();
  if(!legPaused && legStarted && legS.length) legT=setInterval(()=>legGo(legI+1),LEG_DWELL);
}
/* the fill shows how long is left, so the change never feels like an ambush */
function legTick(){
  if(legS.length && legD[legI]){
    const p = (legPaused||!legT) ? 0 : Math.min((performance.now()-legT0)/LEG_DWELL,1)*100;
    legD[legI].style.setProperty('--p', p+'%');
  }
  requestAnimationFrame(legTick);
}

if(legS.length){
  legD.forEach(d=>d.onclick=()=>{legGo(+d.dataset.l); legRestart();});
  $('#legPrev').onclick=()=>{legGo(legI-1); legRestart();};
  $('#legNext').onclick=()=>{legGo(legI+1); legRestart();};
  $('#legPause').onclick=e=>{
    legPaused=!legPaused;
    e.target.textContent=legPaused?'Play':'Pause';
    e.target.setAttribute('aria-label',legPaused?'Resume chapters':'Pause chapters');
    legRestart();
  };
  legRoot.addEventListener('mouseenter',()=>{clearInterval(legT);legT=null;});
  legRoot.addEventListener('mouseleave',legRestart);
  legRoot.addEventListener('focusin',()=>{clearInterval(legT);legT=null;});
  legRoot.addEventListener('focusout',legRestart);
  document.addEventListener('visibilitychange',()=>document.hidden?(clearInterval(legT),legT=null):legRestart());

  /* only start once the section is actually on screen, and stop when it leaves */
  if('IntersectionObserver' in window){
    new IntersectionObserver(es=>es.forEach(e=>{
      if(e.isIntersecting){ if(!legStarted){legStarted=true; legGo(0);} legRestart(); }
      else { clearInterval(legT); legT=null; }
    }),{threshold:.35}).observe(legRoot);
  } else { legStarted=true; legRestart(); }

  /* swipe on touch, arrow keys on desktop */
  let sx=0, sy=0, swiping=false;
  legStage.addEventListener('touchstart',e=>{
    if(e.touches.length!==1) return;
    sx=e.touches[0].clientX; sy=e.touches[0].clientY; swiping=true;
  },{passive:true});
  legStage.addEventListener('touchend',e=>{
    if(!swiping) return; swiping=false;
    const t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
    if(Math.abs(dx)>48 && Math.abs(dx)>Math.abs(dy)*1.6){ legGo(legI+(dx<0?1:-1)); legRestart(); }
  },{passive:true});
  legRoot.addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'){e.preventDefault(); legGo(legI+1); legRestart();}
    if(e.key==='ArrowLeft'){e.preventDefault(); legGo(legI-1); legRestart();}
  });

  addEventListener('resize',()=>{clearTimeout(window.__legR);window.__legR=setTimeout(legHeight,90);});
  addEventListener('load',legHeight);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(legHeight);
  requestAnimationFrame(()=>requestAnimationFrame(legHeight));
  if(reduce) $('#legPause').textContent='Play';
  legTick();
}

/* enlarge the occasions poster */
(function(){
  const btn=document.getElementById('belongsBtn'), box=document.getElementById('lbox'),
        im=document.getElementById('lboxImg'), src=document.getElementById('belongsImg');
  if(!btn||!box) return;
  let last=null;
  function open(){
    last=document.activeElement;
    im.src=src.src; im.alt=src.alt;
    box.classList.add('open');
    document.getElementById('lboxClose').focus();
  }
  function close(){ box.classList.remove('open'); if(last) last.focus(); }
  btn.onclick=open;
  document.getElementById('lboxClose').onclick=close;
  box.addEventListener('click',e=>{ if(e.target!==im) close(); });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'&&box.classList.contains('open')) close(); });
})();

const burger=$('#burger'), nav=$('#nav');
if(burger&&nav){
  const setNav=o=>{ nav.classList.toggle('open',o); burger.setAttribute('aria-expanded',o); };
  burger.addEventListener('click',e=>{ e.stopPropagation(); setNav(!nav.classList.contains('open')); });
  /* a menu you cannot dismiss is worse than no menu: close it on a link, on
     Escape, and on a tap anywhere outside the bar */
  nav.querySelectorAll('.lk').forEach(a=>a.addEventListener('click',()=>setNav(false)));
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') setNav(false); });
  document.addEventListener('click',e=>{ if(!nav.contains(e.target)) setNav(false); });
}

const fields=[['cn',v=>v.trim().length>1],['ce',v=>EM.test(v.trim())],['ct',v=>v!==''],['cm',v=>v.trim().length>4]];
fields.forEach(([id])=>{
  const el=$('#'+id); if(!el) return;
  el.addEventListener('input',()=>{
    const e=$('#e-'+id); if(e) e.classList.remove('show');
    el.classList.remove('bad');
  });
});

/* paint() drives the root palette from the carousel. Off the home page the
   palette belongs to the section Liquid rendered, so leave it alone. */
if(document.getElementById('stage')){
  paint(0,false);
  /* and start the slideshow. Without this the timer was only ever set by a
     click handler, so the hero sat on poster one until you touched it. */
  restart();
}



/* ---------- add-to-cart toast ---------- */
let toastT=null;
function toast(msg){
  let el=document.getElementById('gtoast');
  if(!el){
    el=document.createElement('div');
    el.id='gtoast'; el.className='gtoast'; el.setAttribute('role','status');
    document.body.appendChild(el);
  }
  const shopUrl=(window.GOLI&&window.GOLI.flavoursUrl)||'/collections/all';
  el.innerHTML='<span>'+msg+'</span>'
    +'<a class="gtoast-a" href="'+((window.GOLI&&window.GOLI.cartUrl)||'/cart')+'">View cart</a>'
    +'<a class="gtoast-a alt" href="'+shopUrl+'">Keep shopping</a>';
  el.classList.add('show');
  clearTimeout(toastT);
  toastT=setTimeout(()=>el.classList.remove('show'), 4000);
}

/* ---------- flavour picker on a case card ----------
   Delegated, because the cases band appears on the home, collection and
   product templates and can hold more than one picker. Every option is just
   a variant id, so choosing a flavour is a swap of the hidden input. */
document.addEventListener('click', e=>{
  const b = e.target.closest('.fc');
  if(!b || b.dataset.target === 'pdp') return;
  const uid = b.dataset.target;
  const group = b.closest('.fcase');
  if(!group) return;

  group.querySelectorAll('.fc').forEach(o=>{
    o.classList.toggle('on', o===b);
    o.setAttribute('aria-checked', o===b);
  });

  const set=(id,fn)=>{ const el=document.getElementById(id); if(el) fn(el); };
  set('cp-id-'+uid,    el=>el.value = b.dataset.vid);
  set('cp-flav-'+uid,  el=>el.value = b.dataset.flav);
  set('cp-price-'+uid, el=>el.textContent = b.dataset.price);
  set('cp-note-'+uid,  el=>el.textContent = b.dataset.note);
  set('cp-btn-'+uid,   el=>{
    const ok = b.dataset.avail === 'true';
    el.disabled = !ok;
    el.textContent = ok ? (el.dataset.cta || 'Add to cart') : 'Sold out';
  });
  pop();
});

/* arriving with a hash from another page — /#play, /#legacy, /#findus */
(function(){
  function scrollToHash(){
    const frag = location.hash.replace(/^#\/?/, '');
    if(!frag) return;
    const el = document.getElementById(frag);
    if(!el) return;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      if(typeof jump === 'function') jump(frag);
      else el.scrollIntoView({behavior:'smooth', block:'start'});
    }));
  }
  addEventListener('load', scrollToHash);
  addEventListener('hashchange', scrollToHash);
  if(document.readyState !== 'loading') setTimeout(scrollToHash, 60);
})();
